/**
 * SmartCMR Master Logo — NO tagline, just icon + SMART CMR
 * 
 *   <SmartCMRLogo />       → Light bg: navy SMART + blue CMR
 *   <SmartCMRLogo dark />  → Dark bg: white SMART + blue CMR (uses dark PNG)
 */

export const SmartCMRLogo = ({ dark = false, height = 36, className = '' }) => {
  if (dark) {
    return (
      <img
        src="/smartcmr-dark.png"
        alt="SMART CMR"
        style={{ height, width: 'auto', flexShrink: 0 }}
        className={className}
      />
    );
  }

  const w = height * 0.78;
  const fontSize = height * 0.44;

  return (
    <div className={`flex items-center ${className}`} style={{ gap: height * 0.28 }}>
      <svg width={w} height={height} viewBox="0 0 280 400" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
        <polygon points="140,0 280,80 210,120 140,80" fill="#0967D9"/>
        <polygon points="0,80 140,0 140,80 70,120" fill="#3FA4E8"/>
        <polygon points="0,80 70,120 70,200 0,160" fill="#0967D9"/>
        <polygon points="210,120 280,80 280,160 210,120" fill="#3FA4E8"/>
        <polygon points="70,120 140,80 280,160 210,200 140,160 70,200" fill="#ffffff"/>
        <polygon points="70,200 140,160 210,200 140,240" fill="#ffffff"/>
        <polygon points="140,160 280,240 280,320 210,360 210,280 140,240" fill="#071329"/>
        <polygon points="70,200 140,240 140,320 70,280" fill="#ffffff"/>
        <polygon points="0,240 70,280 140,320 70,360 0,320" fill="#9CA3AF"/>
        <polygon points="70,280 140,320 140,400 70,360" fill="#9CA3AF"/>
      </svg>
      <div className="flex items-baseline" style={{ gap: '0.18em' }}>
        <span style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontSize, fontWeight: 900, letterSpacing: '1px', color: '#0A1F44', lineHeight: 1 }}>SMART</span>
        <span style={{ fontFamily: 'Arial, Helvetica, sans-serif', fontSize, fontWeight: 900, letterSpacing: '1px', color: '#1E5BFF', lineHeight: 1 }}>CMR</span>
      </div>
    </div>
  );
};

export default SmartCMRLogo;
